import { render, staticRenderFns } from "./P03Profit.vue?vue&type=template&id=c83c0c94&lang=pug"
import script from "./P03Profit.vue?vue&type=script&lang=js"
export * from "./P03Profit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports